import React from "react";
import Header from "../Header/Header.js";
import Firstsec from "./First-section/Firstsec.js";
import Sliders from "./Carousal/Sliders.js" 
import Milestone from "./Milestone/Milestone.js";
import Services from "./Ourservices/OurServices.js";
import Workwith from "./Indusworkwith/Workwith.js";
import Ourprocess from "./Ourprocess/Ourprocess.js";
import Whychooseus from "./WhychooseUs/Whychooseus.js";
import FavoriteTool from "./OurfavoriteTool/FavoriteTool.js";
import Technology from "./Technologystack/Technology.js";
import Ourclient from "./Ourclientword/Ourclient.js";
import Getnotified from "./Getnotified/Getnotified.js";
import Footer from "../Footer/Footer.js";

const Home = () => {
  return (
    <>
      <Header />
      <Firstsec />
      <Sliders />
      <Milestone />
      <Services />
      <Workwith />
      <Ourprocess />
      <Whychooseus />
      <FavoriteTool />
      <Technology />
      <Ourclient />
      <Getnotified />
      <Footer />
    </>
  );
};

export default Home;
